import { ConversationApi, CustomerApi, InboxApi, LiveApi } from 'conversations/api'
import { transformResponseIdToString } from 'conversations/utils/stringIdUtil'
import { EndUser } from 'shared/typings/endUser/EndUser'
import { LastViewedPage } from 'shared/typings/endUser/Presence'
import UpdateCQLRequest from 'shared/typings/endUser/UpdateCQLRequest'

export const fetchEndUser = async (ids: string[]): Promise<EndUser[]> => {
  if (ids.length === 0) {
    return []
  }
  const queryParams = ids.map((i) => `endUser=${i}`).join('&')
  const res = await InboxApi.get<EndUser[]>(`/data/endusers?${queryParams}`, {
    transformResponse: transformResponseIdToString('id'),
  })
  return res.data
}

export interface UpdateCQLResponse {
  result: string
  ok: boolean
}

export const updateCQL = ({
  endUserId,
  score,
  conversationId,
}: UpdateCQLRequest): Promise<UpdateCQLResponse> =>
  CustomerApi.post<UpdateCQLRequest, UpdateCQLResponse>(`/end_users/${endUserId}/cql`, {
    conversationId,
    score,
  })

export const fetchLastViewedPage = async (endUserId: string): Promise<LastViewedPage[]> => {
  const res = await LiveApi.post<LastViewedPage[]>('/visitor/searchWithoutAdditionalFilters', {
    matchAll: [{ property: 'id', operation: 'EQ', value: endUserId }],
    size: 1,
  })

  return res.data
}

interface BannedIps {
  bannedIps: string[]
  bannedEndUserIds?: string[]
}

export const fetchBans = async (): Promise<BannedIps> => {
  const res = await ConversationApi.get('/bans')
  return res.data
}
